import classNames from 'classnames'
import { useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { isValidColor } from 'core-components/library/common/colorSelector/helpers/isValidColor'
import { Controller, ValidateInput, ValidationStatus } from 'core-components/library/validation'

import { COLOR_PLACEHOLDER, DEFAULT_COLORS } from './constants/colors'

import styles from './ColorList.module.scss'

interface IProps {
  value: string
  onChange: (value: string) => void
}

export const ColorList = (props: IProps) => {
  const [color, setColor] = useState<string>(props.value)
  const [canSave, setCanSave] = useState<boolean>(true)
  const [isCustomColor, setIsCustomColor] = useState<boolean>(true)

  useEffect(() => {
    const arrayOfBooleans = Object.values(DEFAULT_COLORS).map((row) => row.includes(props.value))
    setIsCustomColor(!arrayOfBooleans.includes(true))
  }, [props.value])

  return (
    <div className={styles.root}>
      <div className={styles.colorPanel}>
        <table>
          <tbody>
            {Object.values(DEFAULT_COLORS).map((row: string[], trIndex: number) => {
              return (
                <tr key={trIndex}>
                  {row.map((col: string, tdIndex: number) => (
                    <td
                      data-testid={`color-cell-${col}`}
                      className={classNames(styles.col, col === color ? styles.col_isSelected : '')}
                      key={tdIndex}
                      style={{ background: col }}
                      onClick={() => {
                        setIsCustomColor(false)
                        setColor(col)
                      }}
                      tabIndex={0}
                    />
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
        <div
          className={classNames(
            styles.currentColor,
            isCustomColor ? styles['currentColor--customColor'] : ''
          )}
          style={canSave ? { backgroundColor: color } : undefined}
        />
      </div>
      <div className={styles.footer}>
        <div className={styles.footer__body}>
          <Controller
            key={isCustomColor ? 'custom' : 'default'}
            onValidationStatusChange={(result) => {
              setCanSave(result.status === ValidationStatus.Valid)
            }}
          >
            {!isCustomColor ? (
              <Button
                __testId={'color_list_set_custom_color_button'}
                variant={'outlined'}
                onClick={() => {
                  setIsCustomColor(true)
                }}
              >
                Set custom color
              </Button>
            ) : (
              <ValidateInput
                placeholder={COLOR_PLACEHOLDER}
                value={color}
                classes={{ validatorClasses: { root: styles.footer__input } }}
                onChange={setColor}
                checkFn={isValidColor}
              />
            )}
          </Controller>
        </div>

        <div className={styles.footer__actions}>
          <Button
            __testId={'color_list_save_button'}
            disabled={!canSave}
            onClick={() => {
              props.onChange(color)
            }}
          >
            Save
          </Button>
          <Button
            __testId={'color_list_clear_button'}
            variant={'outlined'}
            color={'danger'}
            onClick={() => {
              props.onChange('')
            }}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  )
}
